import { ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StreamingAudioOptions, StreamingMedia } from '@ionic-native/streaming-media/ngx';
import { environment } from 'src/environments/environment';
import { AlertEditNoteComponent } from '../alert-edit-note/alert-edit-note.component';
import { AppState } from '../app.service';
import { CordovaService } from '../cordova.service';
import { LibraryService } from '../my-library/library.service';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { MatDialog } from '@angular/material/dialog';
import { MediaObject } from '@ionic-native/media/ngx';
import { SpinnerService } from '../spinner.service';
import { ToasterService } from '../toaster.service';
import { EmailComposer } from '@ionic-native/email-composer/ngx';
import { AlertController, AlertInput, ModalController, Platform } from '@ionic/angular';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { I18n } from '../i18n.service';
import { PlyrComponent } from '@makiwin/ngx-plyr';
import * as Plyr from 'plyr';
import { Keyboard } from "@awesome-cordova-plugins/keyboard/ngx";
type AudioFiles = {
  // title: string;
  // url: string;
  // cover: string;
  src: string;
  type: string;
};

@Component({
  selector: 'app-full-screen-audio',
  templateUrl: './full-screen-audio.component.html',
  styleUrls: ['./full-screen-audio.component.scss'],
})
export class FullScreenAudioComponent implements OnInit {
  @Input() data: any;
  presignedUrl: any
  isMobile: any
  singleDocument;
  pathName: any;
  player = new Audio;
  duration: any = -1;
  position: any = 30;
  curr_playing_file: MediaObject;
  audioList: AudioFiles[] = [];
  libraryPosts: any
  journalNote: string
  isEditNote: boolean
  stepNumber: number
  isCasualDocument: boolean
  journalPosts;
  pdfSrc: any;
 @ViewChild(PlyrComponent)
 plyr: PlyrComponent;

// or get it from plyrInit event
playerInit: Plyr;

 audioSources = [
  ];

  constructor(private socialSharing: SocialSharing,
    private appState: AppState,
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef,
    private cordovaService: CordovaService, 
    private dialog: MatDialog, 
    private alertController:AlertController,
    private i18n: I18n,
    private toasterService: ToasterService,
    private libraryService: LibraryService, 
    private modalController: ModalController,
    private router: Router, 
    private streamingMedia: StreamingMedia,
    public platform: Platform,
    public keyboard: Keyboard,
    private transfer: FileTransfer, 
    private file: File,) {
    this.libraryPosts = this.appState.get('journalPost')
    this.isCasualDocument = this.appState.get('isCasualDocument')
    this.journalPosts = this.data;
    this.isMobile = this.appState.get('isMobile');
    this.singleDocument = this.appState.get('singleDocument');
    this.presignedUrl = environment.preSignedUrl
    console.log("presignedt", this.presignedUrl);
    this.pathName = this.appState.get('journalPathName')
  
    if (this.libraryPosts) {
      // if (this.libraryPosts?.questions[0]) {
      //   this.stepNumber = this.libraryPosts?.questions[0].startDay
      // } else if(this.libraryPosts?.documents[0]){
      //   this.stepNumber = this.libraryPosts?.documents[0].startDay
      // } else if(this.libraryPosts?.contentSurveys[0]){
      //   this.stepNumber = this.libraryPosts?.contentSurveys[0].startDay
      // } else if(this.libraryPosts?.habits[0]){
      //   this.stepNumber = this.libraryPosts?.habits[0].startDay
      // } else if(this.libraryPosts?.inoutScreens[0]){
        this.stepNumber = this.libraryPosts?.data?.position 
      //}
    }
    else {
      this.stepNumber =this.appState.get('journalStepNumber')
    }
  }

  ngOnInit() {
    this.journalPosts = this.data;
    this.player.src = this.journalPosts.link;
    this.duration = this.player.duration;
    // const a1: AudioFiles = { url: this.journalPosts.link, title: this.journalPosts.title, cover: this.journalPosts.imageUrl };
    // this.audioList.push(a1);
    const audioType = this.detectAudioType(this.journalPosts.link)
    const a1 = { src: this.journalPosts.link, type: audioType }
    this.audioList.push(a1);
  }
  played(event: Plyr.PlyrEvent) {
    console.log('played', event);
  }

  play(): void {
    this.playerInit.play(); // or this.plyr.player.play()
  }
detectAudioType(audioUrl: string): string {
    const extension = audioUrl.split('.').pop()?.toLowerCase(); // Extract file extension
    switch (extension) {
      case 'mp3':
        return 'audio/mp3';
      case 'wav':
        return 'audio/wav';
      case 'ogg':
        return 'audio/ogg';
      case 'm4a':
        return 'audio/mp4'; // For .m4a or .mp4 audio files
      case 'aac':
        return 'audio/aac';
      default:
        return 'audio/mpeg'; // Default type
    }
  }
  playRemoteAudio() {
    this.player.getAttribute.length
    let options: StreamingAudioOptions = {
      successCallback: () => { console.log('Audio played') },
      errorCallback: (e) => { console.log(e) },
      bgImage: this.journalPosts.imageUrl
    };
    this.streamingMedia.playAudio(this.journalPosts.link, options);
  }

  close() {
    this.appState.set('singleDocNote', undefined)
    localStorage.removeItem('journalNote')
    console.log('this.isCasualDocument :', this.isCasualDocument);
    this.appState.set('isDocumentClosed',true);
    if (this.isCasualDocument) {
      this.appState.set('isCasualDocument', undefined) 
    }
    this.modalController.dismiss();
  }
  getNoteContent(post){
    if (post) {
      let note = post
      var b = JSON.stringify(note);
      let testNote = b.replace(/\\/g, '');
      let testNote1 = testNote.replace(/[\[\]']+/g, '')
      this.journalNote = testNote1.replace(/"/g, '');
      console.log('journalNote',this.journalNote);
    }
  }

  resizeHeight(){
    this.keyboard.onKeyboardDidShow().subscribe((info) => {
         const mobileLoginScreens = document.querySelector('.alert-wrapper.ion-overlay-wrapper');
         mobileLoginScreens.setAttribute('style', `margin-top: -200px`);
          console.log('keyboard show');
       });

       this.keyboard.onKeyboardDidHide().subscribe(() => {
        const mobileLoginScreens = document.querySelector('.alert-wrapper.ion-overlay-wrapper');
          mobileLoginScreens.setAttribute('style', `margin-top: 0`);
        console.log('keyboard hide');
      })
  }

  async openNotesModal() {
    if (localStorage.getItem('journalNote')) {      
      this.appState.set('singleDocNote', localStorage.getItem('journalNote'))
    } else {
      this.appState.set('singleDocNote', this.journalPosts?.notes)
    }

    let note = this.appState.get('singleDocNote')
    this.getNoteContent(note);  
    const alert =await this.alertController.create({
      header: this.i18n.t("Notes"),
      inputs:[
        {
          type:'textarea',
          name:'textareaValue',
          value:this.journalNote,
          cssClass: this.platform.is('android') ? 'alert-textarea note-area-border' : 'alert-textarea'
        },
      
      ],
      buttons: [
        {
          text:this.i18n.t('Save'),
          cssClass:'custom-alert',
          handler:(alertData: AlertInput)=>{
            let noteText;
            noteText = alertData['textareaValue'];

            localStorage.setItem('journalNote', alertData['textareaValue']);
            this.appState.set('singleDocNote', noteText)
            this.journalNote = noteText
            this.saveNote()
          }
        }
      ]
    })
    await alert.present();
    this.resizeHeight();
  }

  share(event, document) {
    event.stopPropagation()
    let isPresignedURL = document.link.includes(this.presignedUrl)?document.link.includes(this.presignedUrl): document.link.includes(environment.preSignedCloudFrontUrl)
    if(this.isMobile){
      try {
        this.downloadFile(document.link)
      } catch (error) {
        console.log('error :', error);
      }
    }else{
      this.openMailTo(isPresignedURL, document.title, document.link)
    }
  }

  downloadFile(url) {
    if (url.includes(".pdf")) {
      const transfer = this.transfer.create();
      let path = null;
      const name = url.substr(url.lastIndexOf("/") + 1);
      const fileName = name.split("?")[0];
      if (this.platform.is("ios")) {
        path = this.file.documentsDirectory;
      } else {
        path = this.file.dataDirectory;
      }
      transfer.download(url, this.file.dataDirectory + fileName).then((entry) => {
        this.pdfSrc = entry.toURL()
        console.log('this.pdfSrc :', this.pdfSrc);
        if (this.pdfSrc) {
          this.socialSharing.share("", "", this.pdfSrc, "")
            .then((entries) => {
              console.log('success ' + JSON.stringify(entries));
            })
            .catch((error) => {
              console.log('error ' + JSON.stringify(error));
            });
        }
      }, (error) => {
        console.log('download failed: ', error);
      });
    } else {
      this.socialSharing.share("", "", "", url)
        .then((entries) => {
          console.log('success ' + JSON.stringify(entries));
        })
        .catch((error) => {
          console.log('error ' + JSON.stringify(error));
        });
    }
  }

  openMailTo(isPresignedURL, subject, body) {
    if (isPresignedURL) {
      location.href = 'mailto:%20' +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(body + ' \n \n Note: This link will expire in 7 days.')

      this.cordovaService.openMail('mailto:%20' +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(body + ' \n \n Note: This link will expire in 7 days.'))

      return true
    } else {
      location.href = 'mailto:%20' +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(body)

      this.cordovaService.openMail('mailto:%20' +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(body))

      return true
    }
  }

  editNote(){
    this.isEditNote = true
  }

  saveNote(){
    this.isEditNote = false
    let postId,requestData;
    // if (this.isCasualDocument) {
      if(this.journalPosts || this.libraryPosts){
        postId = this.journalPosts?this.journalPosts?.id: this.libraryPosts.id

      }
      else {
        postId = this.singleDocument?.id
      }
       if (this.isCasualDocument) {
       requestData = {
        // 'text': [this.journalNote],
        // 'pathId': null,
        // 'contentSurveyId': null,
        // 'habitId': null,
        // 'pollId': null,
        // 'documentId': postId,
        // 'editedDocumentUrl':this.singleDocument?.editedDocumentUrl,
        // 'questionId': null,
        // 'inoutScreenId': null,
        // 'routineInfoId': null,
        // 'screenId': null
        screen_id: this.singleDocument?.screenId,
        step_id: this.singleDocument?.stepId,
        note: this.journalNote,
        saved_type: 'document'
      }
    }
    else {
      requestData = {
        screen_id: this.libraryPosts?.screen_id,
        step_id: this.libraryPosts?.step_id,
        note: this.journalNote,
        saved_type: 'document'
      }
    }
      this.libraryService.save(requestData).subscribe((response) => {
        console.log('response :', response);
        if (this.appState.get('isDocumentOpenedFromFoozi') == false) {
          this.appState.set('isDocumentOpenedFromFoozi', true);
        }
        this.toasterService.success(this.i18n.t('Note saved.'))
      },
        (error) => {
          console.log('error :', error);
        })
    // } else {
    //   postId = this.libraryPosts.id
    //   const requestData = {
    //     id: postId,
    //     text: this.journalNote
    //   }
    //   this.libraryService.editNote(requestData).subscribe(
    //     (response) => {
    //       if (this.appState.get('isDocumentOpenedFromFoozi') == false) {
    //         this.appState.set('isDocumentOpenedFromFoozi', true);
    //       }
    //       console.log('response :', response);
    //       this.toasterService.success(this.i18n.t('Note saved.'))
    //     },
    //     (error) => {
    //       console.log('Error for feedback ', error)
    //     }
    //   )
    // }
    
  }

  adjustForKeyboard(isKeyboardVisible: boolean,info) {
      const element = document.querySelector('.src-overflow') as HTMLElement;
     
      if (element ) {
        if (isKeyboardVisible) {
          if (this.platform.is('ios')) {
              element.style.height = `calc(100vh - ${info.keyboardHeight}px -20px)`;
          }
          else if (this.platform.is('android')) {
             element.style.height = `calc(100vh - ${info.keyboardHeight}px - 20px)`;
          }
        } else {
          element.style.height ='100vh';
        }
      }
    }
  
    @HostListener('click', ['$event'])
    onLinkClick(e) {
       this.keyboard.onKeyboardWillShow().subscribe((info) => {
        this.adjustForKeyboard(true,info);
      });
      this.keyboard.onKeyboardWillHide().subscribe((info) => {
        this.adjustForKeyboard(false,info);
      });
    }
  

}
